<template>
  <div class="content">
    <h2 class="pl-3">{{ father }} | Notas Críticas</h2>

    <v-card-title>
      <v-row align="end">
        <v-col cols="6" offset-xs3>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
        </v-col>
        <v-col md="auto" offset-xs3>
          <v-tooltip bottom class="text-right">
            <template v-slot:activator="{ on }">
              <v-btn color="blue-grey" class="ma-2 white--text" fab v-on="on" @click="descargarPDF">
                <v-icon dark>mdi-cloud-download</v-icon>
              </v-btn>
            </template>
            <span>Descargar Planilla</span>
          </v-tooltip>
        </v-col>
      </v-row>
    </v-card-title>

    <v-data-table
      :headers="headers"
      :items="alumnos"
      :search="search"
      ref="lista_promedios"
      class="elevation-1"
    ></v-data-table>
  </div>
</template>

<script>
import API from "@/components/_config/conf";

export default {
  data() {
    return {
      search: "",
      rowsPerPageItems: [10, 20, 50],
      pagination: {
        rowsPerPage: 10
      },
      headers: [
        {
          text: "",
          align: "left",
          sortable: false,
          value: ""
        },
        {
          text: "Alumno",
          align: "left",
          sortable: false,
          value: "nombre_alumno"
        },
        {
          text: "Curso",
          sortable: false,
          value: "curso"
        },
        {
          text: "Promedio",
          sortable: false,
          value: "promedio"
        },
        {
          text: "Peridodo",
          sortable: false,
          value: "gruponota"
        },
        {
          text: "Materia",
          sortable: false,
          value: "materia"
        }
      ],
      alumnos: []
    };
  },
  props: ["father"],
  mounted: function() {
    this.$emit("notasCriticas:mostrarOcultarPreload");
    let params = "parametro=criticas&curso=''";
    let resultado = API.enviar("get", "obtenerMejoresNota", params);
    resultado
      .then(result => {
        if (result.data.msj == "ok") this.alumnos = result.data.result;
        this.$emit("notasCriticas:mostrarOcultarPreload");
      })
      .catch(() => {
        //console.log("catch obtenerMateriasDeProfesor-> params: ", params);
      });
  },
  methods: {
    mayus(str) {
      let srt_result = API.ucFirst(str);
      return srt_result;
    },
    descargarPDF: function() {
      console.log("descargarPDF Aspirante");
      window.open(
        API.PORT +
          API.PATH +
          "?funcion=descargarReporteNotasCriticas&curso=" +
          this.search
      );
    }
  }
};
</script>

<style scoped>
.content {
  width: 100%;
}

h2 {
  padding-bottom: 20px;
}
</style>